import styled from 'styled-components';
import { dateFormatter } from 'helpers/dateFormatter';
import { Container, Col, Row } from 'components/atoms/Grid';
import Colors from 'components/tokens/Colors';
import Text from 'components/atoms/Text';
import Tag from 'components/molecules/Tag';
import Icon from 'components/atoms/Icon';
import Link from 'components/atoms/Link';

import RouterLink from 'components/atoms/RouterLink';
import { useEditor } from 'providers/generalContext';
import getNewsUrl from 'helpers/getNewsUrl';
import { Fragment } from 'react';
import copy from 'copy-to-clipboard';
import { notification } from 'antd';
import { utcToZonedTime } from 'date-fns-tz';

export const renderColor = color => {
    switch (color) {
        case 'orange':
            return Colors.educationOrange;
        case 'green':
            return Colors.educationGreen;
        case 'blue':
            return Colors.educationBlue;
        case 'yellow':
            return Colors.educationYellow;
        default:
            return Colors.educationGreen;
    }
};

const copyLink = async url => {
    await copy(url);
    notification.success({
        message: 'Link copiado para a área de transferência'
    });
};

function HeaderEducationArticle({ article }) {
    const color = article.content.label_color;
    const authors = article.content.authors;
    const location = article.content.authors_location;

    const timeZone = 'America/Sao_Paulo';
    const date = article.content.schedule ?
      dateFormatter(article.content.schedule.replace(" ", "T") + ":00Z") :
      article.first_published_at ?
      dateFormatter(article.first_published_at) :
      ''

    const zonedFirstPublishedAt = utcToZonedTime(date, timeZone);

    const modifiedDate = article?.content?.modified_date && `${article?.content?.modified_date}Z`;


    const migrateDate = new Date('05/03/2022Z');
    const publishedDate = zonedFirstPublishedAt;

    const { isStoryblokEditor } = useEditor();

    function handleModified() {
        if (modifiedDate && modifiedDate !== '') {
            return `Atualizado: ${dateFormatter(modifiedDate)}`;
        }

        return null;
    }

    return (
        <Container px="1.5 1">
            <Row justifyContent="center" mt="8 12" mb="2 6">
                {article?.content?.custom_hat ||
                    (article?.content?.hat && (
                        <Col size="12 10" mb="3 6" text="center">
                            <RouterLink
                                to={`/educacao/categoria/${article?.content?.hat?.replace(/( )+/g, '-')}`}
                                decoration="none"
                                editor={isStoryblokEditor}
                                weight="normal"
                            >
                                <Tag
                                    education
                                    bg={renderColor(color)}
                                    color={color === 'orange' || color === 'yellow' ? Colors.white : Colors.black}
                                >
                                    {article?.content?.custom_hat || article?.content?.hat}
                                </Tag>
                            </RouterLink>
                        </Col>
                    ))}
                <Col size="12 10" mb="3 5" text="center">
                    <Text title size="48 72">
                        {article?.name}
                    </Text>
                </Col>
                <Col size="12 10">
                    <Row>
                        <Col size="12 4" mb="3 0">
                            <Row>
                                <Col text="center left">
                                    <Text body2 highlight color={Colors.grey}>
                                        {
                                          article.content.schedule ?
                                          dateFormatter(article.content.schedule.replace(" ", "T") + ":00Z") :
                                          article.first_published_at ?
                                          dateFormatter(article.first_published_at) :
                                          ''
                                        }
                                    </Text>
                                </Col>
                            </Row>

                            {
                                // remove data de atualização para notícias migradas, vão estar no corpo do texto
                                publishedDate > migrateDate && (
                                    <Row>
                                        <Col>
                                            <Text body2 color={Colors.grey}>
                                                {handleModified()}
                                            </Text>
                                        </Col>
                                    </Row>
                                )
                            }
                        </Col>
                        <Col size="12 4" text="left center" mb="3 0">
                            <Row justifyContent="flex-start center">
                                <Col text="left" pl="1 6">
                                    <Text body2 highlight color={Colors.grey}>
                                        {authors?.map((author, index) => {
                                            const name = author?.name?.split(',');
                                            const url = author?.fullSlug;

                                            if (index + 1 === authors?.length - 1) {
                                                return (
                                                    <Fragment key={index}>
                                                        <Link href={`/${url}`} color={Colors.grey}>
                                                            {name?.[0]}
                                                        </Link>
                                                        {authors?.length === 3 ? <br /> : null} e{' '}
                                                    </Fragment>
                                                );
                                            } else if (index + 1 !== authors?.length) {
                                                return (
                                                    <Fragment key={index}>
                                                        <Link href={`/${url}`} color={Colors.grey}>
                                                            {name?.[0]}
                                                        </Link>
                                                        ,{' '}
                                                    </Fragment>
                                                );
                                            } else {
                                                return (
                                                    <Link key={index} href={`/${url}`} color={Colors.grey}>
                                                        {name?.[0]}
                                                    </Link>
                                                );
                                            }
                                        })}
                                    </Text>
                                </Col>
                            </Row>
                            <Row justifyContent="flex-start center">
                                <Col text="left" pl="1 6">
                                    <Text body2 color={Colors.grey}>
                                        {location}
                                    </Text>
                                </Col>
                            </Row>
                        </Col>

                        <Col text="right" size="12 3" pl="2 1" pr="5 1">
                            <Row justifyContent="space-between flex-end">
                                <SocialLink
                                    href={`https://twitter.com/intent/tweet?url=https://lupa.uol.com.br${getNewsUrl(
                                        article.full_slug,
                                        article.first_published_at
                                    )}&title=${article.name}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Icon name="Twitter" color={Colors.grey} />
                                </SocialLink>
                                <SocialLink
                                    href={`https://www.facebook.com/sharer/sharer.php?u=https://lupa.uol.com.br${getNewsUrl(
                                        article.full_slug,
                                        article.first_published_at
                                    )}&title=${article.name}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Icon name="Facebook" color={Colors.grey} />
                                </SocialLink>
                                <SocialLink
                                    href={`whatsapp://send?text=https://lupa.uol.com.br${getNewsUrl(
                                        article.full_slug,
                                        article.first_published_at
                                    )}&title=${article.name}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Icon name="Whatsapp" color={Colors.grey} />
                                </SocialLink>
                                <SocialLink
                                    href={`https://t.me/share/url?url=https://lupa.uol.com.br${getNewsUrl(
                                        article.full_slug,
                                        article.first_published_at
                                    )}&title=${article.name}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Icon name="Telegram" color={Colors.grey} />
                                </SocialLink>
                                <SocialLink
                                    href={`https://www.linkedin.com/shareArticle?mini=true&url=https://lupa.uol.com.br${getNewsUrl(
                                        article.full_slug,
                                        article.first_published_at
                                    )}&title=${article.name}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Icon name="Linkedin" color={Colors.grey} />
                                </SocialLink>
                                <SocialLink onClick={() => copyLink(window.location.href)}>
                                    <Icon name="Share" color={Colors.grey} />

                                    <span className="popover">copiado!</span>
                                </SocialLink>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

const SocialLink = styled.a`
    margin-right: 15px;

    &:last-child {
        margin-right: 0;

        &:hover {
            svg {
                path {
                    stroke: ${Colors.black};
                }

                circle {
                    stroke: ${Colors.black};
                    transition: all ease 0.5s;
                }
            }
        }
    }

    :hover {
        svg:hover {
            path {
                fill: ${Colors.black};
                transition: all ease 0.5s;
            }
        }
    }

    .popover {
        position: absolute;
        bottom: 0;
        right: -80px;

        background-color: ${Colors.lightGrey};
        color: ${Colors.grey};
        border-radius: 4px;
        padding: 5px 10px;

        opacity: 0;
        transition: all ease 0.3s;
    }
`;

export default HeaderEducationArticle;
